import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { NgClass } from '@angular/common';
import {
  SeedListResponse
} from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/seed-list.response';

@Component({
  selector: 'vw-seed-item',
  imports: [
    TranslatePipe,
    SharedModule,
    NgClass,
  ],
  templateUrl: './seed-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './seed-item.component.scss'
})
export class SeedItemComponent implements OnChanges {
  @Input() seed: SeedListResponse;
  imageUrl: string = '';

  ngOnChanges() {
    //TODO - Implement this method
    if (this.seed && this.seed.cultivation && (this.seed.cultivation as any).files && (this.seed.cultivation as any).files.length > 0) {
      this.imageUrl = (this.seed.cultivation as any).files[(this.seed.cultivation as any).files.length - 1].cdnUrl;
    }
  }

}
